<template>
  <div class="panel">
    <div class="title">
      <a class="back" @click="backPage">
        <i class="iconfont icon-icon_return" />返回
      </a>
      <span>{{ template.name }}</span>
    </div>
    <div class="body">
      <el-table
        :data="advertisingData"
        :border="false"
        :fit="true"
        row-key="id"
        style="width: 100%"
      >
        <el-table-column align="center" label="下架/上线">
          <template #default="scope">
            <el-switch
              v-if="!scope.row.isChildren"
              :value="scope.row.whetherOrNot == 1"
              @change="
                switchAdvertising(
                  scope.row.uid,
                  scope.row.whetherOrNot,
                  scope.row
                )
              "
            />
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          prop="locationName"
          width="150"
          label="广告位"
        >
        </el-table-column>
        <el-table-column align="left" :width="320" label="上线时间">
          <template #default="scope">
            <span v-if="!scope.row.isChildren"
              >{{ scope.row.startTime }}至{{ scope.row.endTime }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="left" label="轮播位">
          <template #default="scope">
            <span>{{ scope.row.name }} </span>
          </template>
        </el-table-column>
        <el-table-column align="right" label="展示数">
          <template #default="scope">
            <span>{{ scope.row.advShow }} </span>
          </template>
        </el-table-column>
        <el-table-column align="right" label="曝光数">
          <template #default="scope">
            <span>{{ scope.row.advExposure }} </span>
          </template>
        </el-table-column>
        <el-table-column align="right" label="曝光数uv">
          <template #default="scope">
            <span>{{ scope.row.advExposureUv }} </span>
          </template>
        </el-table-column>
        <el-table-column align="right" label="阅读数">
          <template #default="scope">
            <span>{{ scope.row.advReading }} </span>
          </template>
        </el-table-column>
        <el-table-column align="right" label="点击数(pv)">
          <template #default="scope">
            <span>{{ scope.row.advPv }} </span>
          </template>
        </el-table-column>
        <el-table-column align="right" label="点击数(uv)">
          <template #default="scope">
            <span>{{ scope.row.advUv }} </span>
          </template>
        </el-table-column>
        <el-table-column align="right" label="转化数">
          <template #default="scope">
            <span>{{ scope.row.turnOverNum }} </span>
          </template>
        </el-table-column>
        <el-table-column align="right" label="3s以上">
          <template #default="scope">
            <span>{{ scope.row.advResidencetime }} </span>
          </template>
        </el-table-column>
        <el-table-column align="right" label="权重">
          <template #default="scope">
            <span>{{ scope.row.computedWeight }}% </span>
          </template>
        </el-table-column>
        <el-table-column align="left" label="状态">
          <template #default="scope">
            <div v-if="scope.row.status == 1" class="status_online">
              {{ getStatusName(scope.row.status) }}
            </div>
            <div v-if="scope.row.status == 0" class="status_outline">
              {{ getStatusName(scope.row.status) }}
            </div>
            <div v-if="scope.row.status == 2" class="status_beforeline">
              {{ getStatusName(scope.row.status) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="left" label="操作">
          <template #default="scope">
            <el-button type="text" @click="toEdit(scope.row.templateUid)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @current-change="ProjectChangePage"
        :page-size="advertisingPageSize"
        layout="total, ->, prev, pager, next"
        :total="advertisingTotal"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getAllTargetLocationMappingDto, updateWhetherOrNotTargetLocationMapping } from '../../API/dropData'
import { getDetailTemplate } from '../../API/template'
import _ from 'lodash'
export default {
  data () {
    return {
      templateUid: this.$route && (this.$route.params.id === 'null') ? null : this.$route.params.id,
      advertisingPageSize: 0,
      advertisingNumber: 0,
      advertisingPages: 0,
      advertisingData: [],
      advertisingTotal: 0,
      template: '',
      statusList: []
    }
  },
  async created () {
    this.advertisingChangePage(1)
    const res = await getDetailTemplate({ templateUid: this.templateUid })
    this.template = res
  },
  methods: {
    getStatusName (status) {
      if (this.statusList.find(item => item.key === status)) {
        return this.statusList.find(item => item.key === status).value
      } else {
        return ''
      }
    },
    toEdit (templateUid) {
      this.$router.push(`/create-project/edit/${templateUid}`)
    },
    async switchAdvertising (targetLocationMappingUid, whetherOrNot, info) {
      if (whetherOrNot === 1) {
        this.$confirm(`暂停后,${info.locationName}广告位会被暂停投放`, `确认暂停${info.locationName}广告位？`, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const data = await updateWhetherOrNotTargetLocationMapping({ targetLocationMappingUid, whetherOrNot: whetherOrNot === 0 ? 1 : 0 })
          if (data === '操作完成') {
            this.$notify({
              title: '成功',
              message: data,
              type: 'success'
            })
          }
          this.advertisingChangePage()
          // const i = this.advertisingData.findIndex(item => item.uid === targetLocationMappingUid)
          // this.advertisingData[i].whetherOrNot = whetherOrNot === 0 ? 1 : 0
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      } else {
        const data = await updateWhetherOrNotTargetLocationMapping({ targetLocationMappingUid, whetherOrNot: whetherOrNot === 0 ? 1 : 0 })
        if (data === '操作完成') {
          this.$notify({
            title: '成功',
            message: data,
            type: 'success'
          })
        }
        this.advertisingChangePage()
        // const i = this.advertisingData.findIndex(item => item.uid === targetLocationMappingUid)
        // this.advertisingData[i].whetherOrNot = whetherOrNot === 0 ? 1 : 0
      }
    },
    async advertisingChangePage (pageNum = this.advertisingNumber) {
      const data = {
        pageNum,
        pageSize: this.advertisingPageSize
      }
      if (this.templateUid) {
        data.templateUid = this.templateUid
      }
      const res = await getAllTargetLocationMappingDto(data)
      const list = res.pageInfo.list
      list.forEach(item => {
        if (item.buryPointRecordRelationTreeDtoList) {
          item.children = item.buryPointRecordRelationTreeDtoList.map(f => {
            return { ...f, id: f.sourceUid + '-' + f.sourceParentUid, isChildren: true }
          })
          item.name = '共' + item.children.length + '个'
        }
        item.id = item.uid + '-' + item.templateUid
      })
      this.advertisingPageSize = res.pageInfo.pageSize
      this.advertisingNumber = res.pageInfo.pageNum
      this.advertisingPages = res.pageInfo.pages
      this.advertisingData = list
      this.advertisingTotal = res.pageInfo.total
      const status = []
      _.map(res.templateTypes, (key, value) => {
        status.push({
          key,
          value
        })
      })
      this.statusList = status
    },
    backPage () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.panel {
  .title {
    display: flex;
    align-items: center;
    .back {
      font-size: 16px;
      color: var(--main-text);
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-bottom: 18px;
      height: 28px;
      border-right: 1px solid var(--form-line);
      width: 90px;
      i {
        font-size: 28px;
      }
    }
    span {
      font-size: 18px;
      font-weight: 500;
      margin-left: 13px;
      color: var(--main-text);
      padding-bottom: 17px;
    }
  }
  .body {
    background-color: var(--white);
    border-radius: 1px;
    padding: 20px 30px;
  }
  .status_online {
    font-size: 11px;
    color: var(--success);
    padding: 1px 2px;
    background-color: var(--light-success);
    display: inline-block;
    border-radius: 2px;
  }
  .status_outline {
    font-size: 11px;
    color: #aeb2ba;
    padding: 1px 2px;
    background-color: var(--gray);
    display: inline-block;
    border-radius: 2px;
  }
  .status_beforeline {
    font-size: 11px;
    color: var(--primary);
    padding: 1px 2px;
    background-color: var(--light-primary);
    display: inline-block;
    border-radius: 2px;
  }
  .pagination {
    width: 100%;
    margin-top: 20px;
  }
}
</style>
